<app-academies-header></app-academies-header>
<section class="body-section academies-profile-inner">
    <div class="container">
        <main>
            <p-toast key="toastmsg"></p-toast>
            <div class=" col-md-12 bottom-container tablesections">
                <div class="header-container box w-100">
                    <div class="col-md-12 d-flex justify-content-between mb-3 headers-headings">
                        <h3 class="section-header">COURTS
                        </h3>
                        <div class="add-edit-btn">
                            <ul>
                                <li>
                                    <button class="add-btn-main" data-bs-toggle="modal" (click)="openmodal()">
                                        <i class='bx bx-plus'></i> Add
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-md-12 top-player p-0">
                        <div class="swiper Courts">
                            <div class="swiper-wrapper">
                                <div class="col-sm-12 branch-list-div  heiglght-div p-0">

                                    <div *ngFor="let court of courtlist " class="swiper-slide">
                                        <div class="blog_card">
                                            <div class="edit-button-show-click">
                                                <button data-bs-toggle="modal" (click)="onClickEdit(court.id)"><i
                                                        class='bx bx-pencil'></i></button>
                                                <button class="delete-btn" data-bs-toggle="modal"
                                                    (click)="onClickDelete(court)"><i class='bx bx-trash'></i></button>
                                            </div>
                                            <div class="blog_card_image">
                                                <img src="{{court.image}}" class="w-100" alt="">
                                            </div>
                                            <div class="blog_card_content">
                                                <h3> Surface: {{court.court}}
                                                </h3>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <!-- Add Pagination -->
                            <!-- <div class="swiper-pagination"></div> -->
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</section>
<!-- Modal -->
<p-dialog [closable]="true" header="Add Court Types" [(visible)]="showingForm" [modal]="true"
    [style]=" {width: '24vw' }" [breakpoints]="{'960px': '60vw', '768px': 'calc(100% - 30px)'}" [baseZIndex]="10000"
    (onHide)="onHighlightModalClose()" [draggable]="false" [resizable]="false" class="add-edit-modal">
    <ng-template pTemplate="header">
        <span class="text-xl font-bold">{{pagetitle}}</span>
    </ng-template>
    <div class="modal-body">

        <form class="form" [formGroup]="courttypesform" novalidate="" (ngSubmit)="onsubmit()">
            <label for="name_login mb-3">Upload Image</label>
            <div class="col-md-12 p-0 upload-image-div">
                <img *ngIf="showUploadedpic" id="blah" src="{{courtimage}}" />
                <!-- <img *ngIf="!showUploadedpic" id="blah" src="assets/img/acadmy-details/180.png" alt="your image" /> -->
                <p-fileUpload name="myfile[]" maxFileSize="{{imageSize}}" customUpload="true"
                    class="file-upload custom-fileupload" (uploadHandler)="picUploader($event)" accept="image/*"
                    auto="auto">
                </p-fileUpload>
            </div>
            <div class="row">
                <div class="col p-0 mt-3">

                    <div class="courtType col-12" style="padding-bottom: 30px;">
                        <label for="courtType" class="w-100">Select Court<span class="
                                mandatory-fields">*</span></label>
                        <p-dropdown inputId="courtType" [options]="courtTypeList" formControlName="courtType"
                            appendTo="body" [filter]="true" placeholder="Select Court" optionLabel="label"
                            [ngClass]="{ 'is-invalid': ((submitted && f.courtType.errors) || (f.courtType.errors && (f.courtType.dirty || f.courtType.touched)))}"
                            (onChange)="onCourtSelect($event)" class="w-100"></p-dropdown>
                        <div *ngIf="((submitted && f.courtType.errors) || (f.courtType.errors && (f.courtType.dirty || f.courtType.touched)))"
                            class="invalid-feedback">
                            <div *ngIf="f.courtType.errors.required">Please Select Court.</div>
                        </div>
                    </div>

                </div>
            </div>
            <div class="modal-footer justify-content-center">
                <button type="submit" class="btn btn-primary p-0">
                    <span *ngIf="isAddMode">Save</span>
                    <span *ngIf="!isAddMode">Update</span>
                </button>
            </div>
        </form>

    </div>
</p-dialog>
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>